import type React from 'react';
import './PageLayout.less';
import { Layout } from 'antd';
import { useSearchParams } from 'react-router-dom';
import ImprivataLogo from '../../assets/Imprivata_Logo.svg?react';
import { isSetup } from '../../utils/utils';

const { Header } = Layout;

export type PageHeaderProps = {
  title?: string;
  rightSlot?: React.ReactNode;
  logoContainerStyles?: React.CSSProperties;
};

const PageHeader = ({ title, rightSlot, ...rest }: PageHeaderProps & React.HTMLAttributes<HTMLDivElement>) => {
  const [searchParams] = useSearchParams();
  const urlParams = new URLSearchParams(searchParams).toString();

  return (
    <Header {...rest} className={`page-header ${rest?.className || ''}`}>
      <div className={'header-content-left'}>
        {isSetup() ? (
          <ImprivataLogo fill={'#2C3F57'} />
        ) : (
          <a href={urlParams ? `/?${urlParams}` : '/'} className={'logo'}>
            <ImprivataLogo fill={'#2C3F57'} />
          </a>
        )}
        {title && <span className={'logo-text'}>{title}</span>}
      </div>
      <div className={'header-content-right'}>{rightSlot}</div>
    </Header>
  );
};

export default PageHeader;
